import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-data_42d0645370d7eb3095e87bacaf027e6f",
  "use": "ic-data_42d0645370d7eb3095e87bacaf027e6f-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"ic-data_42d0645370d7eb3095e87bacaf027e6f\">\n    <path fill=\"#6F737D\" fill-rule=\"nonzero\" d=\"M22.4 8.636h-.8V7H20v1.636h-8V7h-1.6v1.636h-.8c-.883.003-1.597.734-1.6 1.637v13.09c.003.903.717 1.634 1.6 1.637h12.8c.883-.003 1.597-.734 1.6-1.636V10.273c-.003-.903-.717-1.634-1.6-1.637zm0 14.728H9.6V12.727h12.8v10.637z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id